import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "fcida65l3__mask0_1_88496",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20",
        children: _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#fcida65l3__mask0_1_88496)",
        children: [_jsx("path", {
          d: "M20 0H0V20H20V0Z",
          fill: "#436F4D"
        }), _jsx("path", {
          d: "M20 0H0V13.3333H20V0Z",
          fill: "white"
        }), _jsx("path", {
          d: "M20 0H0V6.66667H20V0Z",
          fill: "#CD2A3E"
        }), _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          stroke: "#152361"
        })]
      })]
    }))
  });
};
export default Component;
